import { render, staticRenderFns } from "./PrivateListPage.vue?vue&type=template&id=5534bdce&"
import script from "./PrivateListPage.vue?vue&type=script&lang=js&"
export * from "./PrivateListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports